<template>
  <div class="distributor-box">
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002820')" prop="searchValue">
              <Input :placeholder="$t('key1005861')" v-model.trim="pageParams.searchValue" clearable></Input>
            </Form-item>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation-box">
      <local-tabButton class="mr20" :tabButtonList="enableDisableList" @selectStatus="enableDisableStatusBtn"></local-tabButton>
      <Button type="primary" @click="addUserBtn" v-if="getPermission('ymsDistributorUserInfo_insert')">{{ $t('key1005855') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        highlight-row
        border
        max-height="550"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--修改密码弹窗-->
    <Modal v-model="updatePasswordModal" :title="$t('key1005860')" width="600" :transfer="false"
      :mask-closable="false" @on-visible-change="updatePasswordChange">
      <Form ref="updatePasswordForm" :model="updatePasswordForm" :rules="ruleValidate" :label-width="100" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem" style="width: 95%">
          <Alert type="warning" show-icon style="width: 94%; margin: 0 0 20px 20px;"
          >{{ $t('key1005862') }}</Alert>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005527')" prop="password">
              <div class="flex align-items-center justify-content-between">
                <Input style="width: 70%" v-model="updatePasswordForm.password" :element-id="'updatePasswordForm_password'" clearable></Input>
                <Button style="width: 28%; padding: 0 5px;" @click="getStrongPassword('updatePasswordForm', 'password')">{{ $t('key1005858') }}</Button>
              </div>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <Button @click="updatePasswordModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="updatePasswordBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
    <!--新增、编辑、查看用户弹窗-->
    <editUserModal :roleList="roleList" ref="editUser" @updateData="search()"></editUserModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import editUserModal from "@/views/distributor/components/permissionManage/editUserModal";

export default {
  name: "userManage",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      autofocus: false,
      pageParams: {
        pageNum: 1,
        pageSize: 15,
        status: 1, // 1 启用  0停用
        roleId: null,
        orderBy: 'userName',
        upDown: 'down',
        searchValue: null
      },
      total: 0,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002629'),
          key: 'mobile',
          minWidth: 130,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'),
          key: 'email',
          align: 'left',
          minWidth: 130
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002331'),
          key: 'userName',
          minWidth: 130,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005850'),
          key: 'accountType',
          align: 'left',
          minWidth: 130,
          render(h, params) {
            let text = '';
            let isAdmin = params.row.isAdmin === '1';
            text = isAdmin ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005851') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005852');
            return h('span', {class: isAdmin ? 'distributorThemeColor' : ''}, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005853'),
          key: 'roleName',
          align: 'left',
          minWidth: 130,
          render(h, params) {
            let list = [];
            let roleIdList = params.row.roleIdList || [];
            if (v.roleList.length > 0) {
              v.roleList.map((item) => {
                if (roleIdList.includes(item.roleId)) {
                  list.push(item.roleName);
                }
              });
            }
            return h('span', list.join('、'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'left',
          minWidth: 130,
          render(h, params) {
            let typeList = [
              {type: 'error', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')},
              {type: 'success', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')}
            ];
            let distributorStatus = params.row.distributorStatus ? params.row.distributorStatus : 0;
            return h('Badge', {
              props: {
                status: typeList[distributorStatus].type,
                text: typeList[distributorStatus].text || '--'
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005167'),
          key: 'lastLoginTime',
          align: 'left',
          minWidth: 170,
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.lastLoginTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'left',
          width: 220,
          render(h, params) {
            let isAdmin = params.row.isAdmin === '1';
            let distributorStatus = params.row.distributorStatus ? Number(params.row.distributorStatus) === 1 : false;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      v.$refs['editUser'].isAdmin = isAdmin;
                      v.$refs['editUser'].initFun('look', params.row.userId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsDistributorUserInfo_update'),
                    clickFn: () => {
                      v.$refs['editUser'].isAdmin = isAdmin;
                      v.$refs['editUser'].initFun('edit', params.row.userId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005860'),
                    show: v.getPermission('ymsDistributorUserInfo_update'),
                    clickFn: () => {
                      v.axios.post(api.post_ymsDistributorUserInfo_id + params.row.userId).then(response => {
                        if (response.data.code === 0) {
                          let data = response.data.datas;
                          v.userInfoObj = data;
                          v.updatePasswordModal = true;
                        }
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: !isAdmin && distributorStatus && v.getPermission('ymsDistributorUserInfo_disable'),
                    clickFn: () => {
                      v.enableDisableBtn('disable', params.row.userId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: !isAdmin && !distributorStatus && v.getPermission('ymsDistributorUserInfo_enable'),
                    clickFn: () => {
                      v.enableDisableBtn('enable', params.row.userId);
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      enableDisableList: [
        {selected: false, value: null, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {selected: true, value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002630')},
        {selected: false, value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002631')},
      ],
      updatePasswordModal: false,
      updatePasswordForm: {
        password: ''
      },
      ruleValidate: {
        password: [
          {required: true, validator: v.validatePasswordnoMatchChinese(), trigger: 'blur'}
        ],
      },
      userInfoObj: {},
      roleList: []
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        await this.getRoleList();
        await this.search();
      })();
    },
    // 添加用户
    addUserBtn() {
      this.$refs['editUser'].initFun('add');
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.enableDisableStatusBtn(0, null);
    },
    // 获取所有角色数据
    getRoleList() {
      let v = this;
      v.axios.post(api.post_role_query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          v.roleList = data;
        }
      });
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsDistributorUserInfo_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsDistributorUserInfo_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.tableData = data.list || [];
            if (v.tableData.length > 0) {
              v.tableData.map((item) => {
                item.status = Number(item.status);
              });
            }
            v.$nextTick(() => {
              v.tableLoading = false;
            });
            v.total = data.total;
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 选取状态
    enableDisableStatusBtn(index, value) {
      let v = this;
      v.pageParams.status = value;
      v.enableDisableList.forEach((n, i) => {
        n.selected = i === index;
      });
      v.pageParamsStatus = true;
    },
    // 修改密码的确定按钮
    updatePasswordBtn() {
      let v = this;
      let query = {
        userName: v.userInfoObj.userName,
        email: v.userInfoObj.email,
        mobile: v.userInfoObj.mobile,
        password: v.updatePasswordForm.password,
        userId: v.userInfoObj.userId
      };
      query.roleIdList = v.userInfoObj.roleIdList;
      let ymsPlatformAccountUserRelateBos = [];
      let newList = v.userInfoObj.ymsPlatformAccountUserRelateds;
      if (newList.length > 0) {
        let list = v.handerGrouping(newList, function (item) {
          return [item.platformId];
        }, 'platformId', 'children');
        if (list.length > 0) {
          list.map((ele) => {
            let obj = {
              platformId: ele.platformId,
              ymsPlatformAccountIds: []
            };
            if (ele.children && ele.children.length > 0) {
              ele.children.map((talg) => {
                obj.ymsPlatformAccountIds.push(talg.ymsPlatformAccountId);
              });
            }
            ymsPlatformAccountUserRelateBos.push(obj);
          });
        }
      }
      query.ymsPlatformAccountUserRelateBos = ymsPlatformAccountUserRelateBos;
      v.$refs['updatePasswordForm'].validate((valid) => {
        if (valid) {
          v.axios.put(api.put_ymsDistributorUserInfo, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247'),}).then(response => {
            if (response.data.code === 0) {
              v.updatePasswordModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
            }
          });
        }
      });
    },
    // 启用、停用用户
    enableDisableBtn(type, userId) {
      let v = this;
      // 停用
      if (type === 'disable') {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003176'),
          onOk: () => {
            v.axios.put(api.put_ymsDistributorUserInfo_disable + '?userId=' + userId).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
                v.pageParamsStatus = true;
              }
            });
          },
          onCancel: () => {
          }
        });
      }
      // 启用
      else {
        v.axios.put(api.put_ymsDistributorUserInfo_enable + '?userId=' + userId).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
            v.pageParamsStatus = true;
          }
        });
      }
    },
    // 监听修改密码弹窗
    updatePasswordChange(value) {
      if (!value) {
        this.$refs['updatePasswordForm'].resetFields();
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    editUserModal
  }
};
</script>

<style scoped>

</style>
